<div class="header">
  <div class="mat-h2">{{ 'USERS_SEARCH.users' | translate }}</div>
  <div>
    <div
      [matTooltip]="
        (isPartiallySelected() || isAllSelected())
          ? ('Block_User' | translate)
          : ('USERS_SEARCH.tooltip' | translate)
      "
    >
      <button
        aria-label="trash"
        mat-stroked-button
        color="primary"
        [disabled]="!this.selectedUsers.hasValue()"
        (click)="confirmDeactivate()"
      >
        <mat-icon>block</mat-icon> {{ 'Block_User' | translate }}
      </button>
    </div>
    <mat-form-field
      (keyup)="monitorSearch(search.value)"
      [subscriptSizing]="'dynamic'"
     appearance="outline"  floatLabel="always" >
      <mat-label>{{ 'USERS_SEARCH.search' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'USERS_SEARCH.search_placeholder' | translate"
        #search
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>

@if (noRecordFound) {
<app-not-found [displayMessage]="message"></app-not-found>
}
<table
  class="mat-elevation-z0"
  mat-table
  [dataSource]="userList"
  [ngClass]="noRecordFound ? 'hide' : ''"
  matSort
>
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        color="primary"
        (click)="$event.stopPropagation(); masterToggle()"
        [checked]="selectedUsers.hasValue() && isAllSelected()"
        [indeterminate]="isPartiallySelected()"
        [disabled]="userList === undefined"
      >
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let element; let i = index">
      <mat-checkbox
        color="primary"
        (click)="$event.stopPropagation()"
        (change)="$event ? selectedRecords(element) : null"
        [checked]="selectedUsers.isSelected(element)"
      >
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ 'BRANCH_USERS_TABLE.name' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.name }}
      @if (element.isCompanyAdmin) {
      <mat-chip class="company-admin">{{
        'COMPANY_ADD_USERS.admin' | translate | uppercase
      }}</mat-chip>
      }
      @if (isBranchAdmin(element)) {
      <mat-chip class="branch-admin">
        {{'COMPANY_ADD_USERS.branch_admin' | translate | uppercase}}
      </mat-chip>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'BRANCH_USERS_TABLE.email' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.email }}</td>
  </ng-container>

  <ng-container matColumnDef="branches">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'BRANCH_USERS_TABLE.associated_branches' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <a (click)="$event.stopPropagation(); handleNavigate(element)">{{
        element.branchAssignments.length > 1
          ? element.branchAssignments.length +
            ' ' +
            ('BRANCH_USERS_TABLE.branches' | translate)
          : element.branchAssignments.length + ' ' + ('BRANCH_USERS_TABLE.branch' | translate)
      }}</a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    (click)="$event.stopPropagation(); handleRowClick(row)"
  ></tr>
</table>

<mat-paginator
 [ngClass]="noRecordFound ? 'hide' : ''"
  #paginator
  showFirstLastButtons="true"
  [pageSizeOptions]="[10, 25, 50, 100]"
>
</mat-paginator>
